import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {
  ReorderWorkoutExercisesInput,
  WorkoutRepository,
} from '../ports/workout.repository';

export class ReorderWorkoutExercises
  implements UseCase<[ReorderWorkoutExercisesInput], Workout>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: ReorderWorkoutExercisesInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.reorderExercises(input);
  }
}
